(() => {
  const observers = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-wf-sticky-cta]').forEach((bar) => {
      if (observers.has(bar)) return;
      const hero = document.getElementById(bar.dataset.wfStickyCta);
      if (!hero || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        bar.classList.toggle('is-visible', visible);
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
      });
      observer.observe(hero);
      observers.set(bar, observer);
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-wf-sticky-cta]').forEach((bar) => {
      observers.get(bar)?.disconnect();
      observers.delete(bar);
    });
  });
})();

(() => {
  function setUp(root = document) {
    root.querySelectorAll('[data-wf-qty]').forEach((wrapper) => {
      if (wrapper.dataset.wfQtyReady) return;
      const input = wrapper.querySelector('input[type="number"]');
      if (!input) return;
      wrapper.dataset.wfQtyReady = 'true';
      const buttons = wrapper.querySelectorAll('[data-wf-qty-step]');
      const sync = () => {
        const value = Number(input.value);
        const min = input.min === '' ? 1 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        buttons.forEach((button) => {
          const direction = Number(button.dataset.wfQtyStep);
          button.disabled = input.disabled || (direction < 0 ? value <= min : value >= max);
        });
      };
      buttons.forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const step = Number(input.step) || 1;
          const min = input.min === '' ? 1 : Number(input.min);
          const max = input.max === '' ? Infinity : Number(input.max);
          const current = Number(input.value) || min;
          const next = Math.min(max, Math.max(min, current + step * Number(button.dataset.wfQtyStep)));
          if (next === current) return;
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    });
  }
  setUp();
  document.addEventListener('shopify:section:load', (event) => setUp(event.target));
})();
